
import { Button } from "reactstrap";
import { useDeleteCostBy } from "./api/deleteCostBy";


const DeleteCostBy = ({handleCloseModal, costById}: DeleteCostByProps)  => {
  
  const deleteCostByMutation = useDeleteCostBy({ costById });
  const handleSubmit = async (): Promise<void> => {
    deleteCostByMutation.mutateAsync({ 
      costById: costById
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε την παράμετρο 'Κόστος ανά';</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteCostByProps{
  costById: number;
  handleCloseModal: () => void;
}

export default DeleteCostBy;